var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-card",
    { attrs: { bordered: false } },
    [
      _c("a-table", {
        ref: "table",
        staticClass: "j-table-force-nowrap",
        attrs: {
          size: "middle",
          bordered: "",
          rowKey: "personid",
          scroll: { x: 500 },
          dataSource: _vm.dataSource,
          pagination: _vm.ipagination,
          columns: _vm.columns,
          loading: _vm.loading,
          rowSelection: {
            selectedRowKeys: _vm.selectedRowKeys,
            onChange: _vm.onSelectChange
          }
        },
        on: { change: _vm.handleTableChange }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }